export function getErrorDetails(error: unknown) {
  if (error instanceof Error) {
    return {
      message: error.message,
      stack: error.stack
    };
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    const stack =
      'stack' in error && typeof error.stack === 'string'
        ? error.stack
        : undefined;

    return {
      message: String(error.message),
      stack
    };
  }

  return {
    message: String(error),
    stack: undefined
  };
}
